<template>
  <div class="user">
    <div class="user__avatar">LV</div>
    <div class="user__name">{{ username }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UserInfo',
  computed: {
    ...mapState({
      username: state => state.userInfo.userInfo && state.userInfo.userInfo.username
    })
  },
  mounted() {
    this.$store.dispatch('userInfo/fetchData');
  }
};
</script>
